

import React, { useState, useEffect, Suspense, lazy, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PgeLogin from './Components/Pages/Settings/Login';
import ChatLogin from './Components/Pages/Settings/ChatLogin';
import { PageNotFound } from './Components/Pages/Settings/PgeNotFound';
import { ReactSession } from 'react-client-session';
import { ErrorBoundary } from 'react-error-boundary';
import { glbChangeMode, glbGetConfig, glbRemoveSyncfusionTrial, glbSetLocalStorage, recordlog, GlbGlobalThemeLoading, glbGetLocalStorage } from './Helpers/GlobalFunctions';
import GlobalContext from './Helpers/GlobalContext';
// import DirectLogin from './Components/Pages/directloginflow/DirectLogin';
// import OTPVerification from './Components/Pages/directloginflow/OTPVerification';
// import OreWebhook from './oredesign/orewebhook';
// import SterloGantt from './gantt/sterlogantt';
// import SterBimView from './bim/sterbimview';
// import { ReactFlowProvider } from '@xyflow/react';
// import BluetoothPrinter from './Bluetooth/BluetoothPrinter';
// import PrinterSelection from './Bluetooth/PrinterSelection';
// import BluetoothPrinterNew from './Bluetooth/BluetoothPrinterNew';
// import SmartCodeApp from './Components/smartcodev2/SmartCodeApp';
// import SterCare from './oredesign/stercare';
// import GlobalContextMethods from './Helpers/GlobalCompoonent';
// import OreControl from './oredesign/orecontrolv2';
// import LinkRedirection from './Components/Pages/Settings/LinkRedirection';
// import ThanksPage from './Components/Layouts/ThanksPage';
const OreControl = lazy(() => import('./oredesign/orecontrolv4'));
const LinkRedirection = lazy(() => import('./Components/Pages/Settings/LinkRedirection'));
const ThanksPage = lazy(() => import('./Components/Layouts/ThanksPage'));
const GlobalContextMethods = lazy(() => import('./Helpers/GlobalContextMethods'));
const SmartCodeApp = lazy(() => import('./Components/smartcodev2/SmartCodeApp'));
const SterloGantt = lazy(() => import('./gantt/sterlogantt'));
const BluetoothPrinter = lazy(() => import('./addons/Bluetooth/BluetoothPrinter'));
const PrinterSelection = lazy(() => import('./addons/Bluetooth/PrinterSelection'));
const BluetoothPrinterNew = lazy(() => import('./addons/Bluetooth/BluetoothPrinterNew'));
const OreWebhook = lazy(() => import('./oredesign/orewebhook'));
const OTPVerification = lazy(() => import('./Components/Pages/directloginflow/OTPVerification'));
const DirectLogin = lazy(() => import('./Components/Pages/directloginflow/DirectLogin'));

const myErrorHandler = (error, info) => {
  recordlog({ "error": error, "info": info })
  // Do something with the error
  // E.g. log to an error logging client here
}
function ErrorFallback({ error, resetErrorBoundary, info }) {
  return (
    <>
      <PageNotFound error={error} resetError={resetErrorBoundary} info={info} />
    </>
  )
}
function App() {
  // glbGetConfig();
  ReactSession.setStoreType("localStorage");
  const [token, setToken] = useState(false);
  let lbneedcontextstorage = false;
  let refGlobalComponent = useRef(null);
  let lbdeployedasapplication = true;
  glbRemoveSyncfusionTrial();
  let lspublicurl = "", lsrouterurl = "/sterloapp";
  if (lbdeployedasapplication && process.env.PUBLIC_URL !== undefined && process.env.PUBLIC_URL !== "" && process.env.PUBLIC_URL !== null) {
    lspublicurl = process.env.PUBLIC_URL;
    lsrouterurl = process.env.PUBLIC_URL;
  }
  glbSetLocalStorage("zissterapp", lspublicurl);
  let lsEnvDomain = window.location.host;
  lsEnvDomain = lsEnvDomain.replace(/:/g, "!");
  if (lsEnvDomain === "equaliser.lntecc.com" || lsEnvDomain === "20.204.200.73") {
    lbneedcontextstorage = true;
  }
  useEffect((async) => {
    const fnlLoadInit = async () => {
      setToken(true);
      if (lbneedcontextstorage === true) {
        let lolocalstorage = glbGetLocalStorage("xyghd");
        // console.log(lolocalstorage);
        if (lolocalstorage !== "") {
          // glbSetLocalStorage("glbreflocalstorage", "");
          refGlobalComponent.current.SetContextStorageAll("localstorage", JSON.parse(lolocalstorage));
        }
        window.glbref = refGlobalComponent.current;
      }
      // await fnlLoad()
    };
    fnlLoadInit();
    // GetTenantFromDomain()
    /*if (localStorage.getItem("token") === null) {
      setToken(true);
    } else {
      
    }  */

  }, [])
  async function fnlLoad() {
    await glbSetLocalStorage("clearsession", "");
    await glbGetConfig();
    await glbChangeMode('light');
  }
  /*if (lbneedcontextstorage === true) {
    if (window.glbref !== undefined) {
      let lolocalstorage = window.glbref.GetContextStorageAll("localstorage");
      if (lolocalstorage !== "") {
        glbSetLocalStorage("glbreflocalstorage", lolocalstorage);
      }
    }
    window.onbeforeunload = function (evt) {
      // var message = 'Are you sure you want to reload?';
      if (typeof evt == 'undefined') {
        evt = window.event;
      }
      if (evt) {
        if (window.glbref !== undefined) {
          let lolocalstorage = window.glbref.GetContextStorageAll("localstorage");
          glbSetLocalStorage("glbreflocalstorage", lolocalstorage);
        }
        // evt.returnValue = message;
      }
      // return message;
    }
    if (window.location.pathname.includes("/logout")) {
      if (window.glbref !== undefined) {
        let lolocalstorage = window.glbref.GetContextStorageAll("localstorage");
        glbSetLocalStorage("glbreflocalstorage", lolocalstorage);
      }
    }
  }*/
  return (
    <>
      <div className='d-none'>
        <GlobalContextMethods ref={refGlobalComponent} />
      </div>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={myErrorHandler}
        onReset={() => { }}//resetKeys={[username]}
      >
        <GlobalContext.Provider value={{ status: true, login: {}, localstorage: {} }}>
          {/* <ReactFlowProvider> */}
          <Router>
            <Suspense fallback={<GlbGlobalThemeLoading />}>
              <Routes>
                <Route exact path={lspublicurl + "/"} element={<PgeLogin refglobal={refGlobalComponent.current} />} />
                <Route exact path={lspublicurl + "/gantt"} element={<SterloGantt />} />
                {/* <Route exact path={lspublicurl + "/bim"} element={<SterBimView />} /> */}
                <Route exact path={lspublicurl + "/msso"} element={<PgeLogin />} />
                <Route exact path={lspublicurl + "/sso"} element={<PgeLogin />} />
                <Route exact path={lsrouterurl} element={<PgeLogin />} />
                <Route exact path={lspublicurl + "/openpage"} element={<PgeLogin />} />
                <Route exact path={lspublicurl + "/logout"} element={<PgeLogin />} />
                <Route exact path={lspublicurl + "/subdomain:domainid"} element={<PgeLogin />} />
                <Route exact path={lspublicurl + "/openlink:redirect"} element={<LinkRedirection />} />
                <Route exact path={lspublicurl + "/pagenotfound"} element={<PageNotFound />} />
                <Route exact path={lspublicurl + "/directlogin"} element={<DirectLogin />} />
                <Route exact path={lspublicurl + "/newdesign"} element={<OreControl />} />
                <Route exact path={lspublicurl + "/webhook"} element={<OreWebhook />} />
                <Route exact path={lspublicurl + "/welcome"} element={<ThanksPage />} />
                <Route exact path={lspublicurl + "/otpverification"} element={<OTPVerification />} />
                <Route exact path={lspublicurl + "/chat"} element={<ChatLogin />} />
                <Route exact path={lspublicurl + "/printer"} element={<BluetoothPrinter />} />
                <Route exact path={lspublicurl + "/printernew"} element={<BluetoothPrinterNew />} />
                <Route exact path={lspublicurl + "/printerselection"} element={<PrinterSelection />} />
                <Route exact path={lspublicurl + "/smartcode"} element={<SmartCodeApp />} />
                {/* <Route exact path={lspublicurl + "/care"} element={<SterCare />} /> */}
              </Routes>
            </Suspense>
          </Router>
          {/* </ReactFlowProvider> */}
        </GlobalContext.Provider>
      </ErrorBoundary>
    </>
  );
}

export default App;

/*  <Route exact path="/" element={<Login isAuth={token}/>}/>
            <Route exact path="/home" element={token ? <Home /> : <Navigate to="/"/>}/> 
            <Route exact path="/seeker" element={token ? <Seeker /> : <Navigate to="/"/>}/> 
            <Route path="*" element={<NotFound />}/>*/